exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".page-content{font-size:16px}", "", {"version":3,"sources":["/home/webuser/profi-stout/releases/42/spa/src/pages/policyPage/PolicyPage.vue"],"names":[],"mappings":"AACA,cACE,cAAA,CAAA","file":"PolicyPage.vue?vue&type=style&index=1&id=a11faf02&prod&lang=scss&","sourcesContent":["\n.page-content {\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);

// exports
